<template lang="pug">
	.banner-panel
		.banner-panel__logo
			.banner-panel__logo-close( @click="clickOnBanner('close')" )
				.banner-panel__logo-close-row
				.banner-panel__logo-close-row
			img( :src="settings.app_logo" alt="'logo'" )
		.banner-panel__text
			.banner-panel__text-title(v-text="settings.app_title")
		.banner-panel__btn( @click="clickOnBanner('link')" )
			.banner-panel__btn-text(v-text="'Завантажити'")
</template>

<script>
  import {mapGetters, mapState} from "vuex";

  export default {
		name: 'AppBanner',
		data() {
		  return {
		    isIos: [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
          ].includes(navigator.platform)
          || (navigator.userAgent.includes("Mac") && "ontouchend" in document),
		  }
    },
	  created() {
      if (this.getCookie('showBanner')) {
        this.$store.dispatch('HIDE_BANNER');
      }
    },
		beforeDestroy() {
			if (window.innerWidth >= 1200) {
				document.getElementById('app').style.paddingTop = '0px';
			} else {
				document.getElementById('app').style.paddingTop = '50px';
			}
		},
    computed: {
      ...mapState([
        'settings',
      ]),
    },
	  methods: {
		  clickOnBanner(type) {
		    if(type === 'link') {
          window.location = this.isIos ? this.settings.app_link_ios : this.settings.app_link_android;
          this.setCookie('showBanner', true, 90);
        } else {
          this.setCookie('showBanner', true, 15);
		    }
        this.$store.dispatch('HIDE_BANNER');
      },
      setCookie(name, value, days) {
        let d = new Date;
        d.setTime(d.getTime() + 24*60*60*1000*days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
      },
      getCookie(name) {
        const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
      }
	  },
	}

</script>

<style lang="scss" scoped>
	.banner-panel {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		padding: 5px 10px;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 12;
		background-color: #f2f2f2;
		border-bottom: 1px solid #333333;
		
		&__logo {
			display: flex;
			align-items: center;
			
			&-close {
				width: 15px;
				height: 15px;
				border-radius: 50%;
				background-color: #333333;
				margin-right: 10px;
				display: flex;
				align-items: center;
				
				&-row {
					width: 100%;
					border-top: 1px solid #ffffff;
					
					&:first-child {
						transform: rotate(-45deg) translateY(3px) translateX(2.5px) !important;
					}
					
					&:last-child {
						transform: rotate(45deg) translateY(3px) translateX(-3px) !important;
					}
				}
			}
			
			img {
				width: 50px;
				height: 50px;
			}
		}
		
		&__text {
			padding: 0 10px;
		}
		
		&__btn {
			padding: 5px 10px;
			border: 1px solid #333333;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			background-color: #333333;
			color: #ffffff;
		}
	}

</style>
